import moment from 'moment';

export type StatisticsDateRangeValue = {
    startDate: moment.Moment;
    endDate: moment.Moment;
};

export type StatisticsDateRangePreset = {
    labelKey: string;
    getRange: () => StatisticsDateRangeValue;
};

/**
 * Default quick-select time ranges for the statistics date pickers.
 * Mirrors the selections available in the old UI: Last Week, Last Month,
 * Last Quarter, Last Half Year and Last Year.
 *
 * All ranges are calendar based and never extend beyond yesterday, because
 * statistics data is only collected up to (and including) yesterday - which
 * is also the date picker's maxDate.
 *
 * Ranges are computed relative to now (not yesterday): subtracting a period
 * from yesterday first would shift the result by a whole period whenever
 * today is the 1st of a month (e.g. on Oct 1, yesterday - 1 month lands in
 * August instead of September).
 */
export const STATISTICS_DATE_RANGE_PRESETS: StatisticsDateRangePreset[] = [
    {
        labelKey: 'Last Week',
        getRange: () => ({
            startDate: moment().subtract(1, 'week').startOf('week'),
            endDate: moment().subtract(1, 'week').endOf('week'),
        }),
    },
    {
        labelKey: 'Last Month',
        getRange: () => ({
            startDate: moment().subtract(1, 'month').startOf('month'),
            endDate: moment().subtract(1, 'month').endOf('month'),
        }),
    },
    {
        labelKey: 'Last Quarter',
        getRange: () => ({
            startDate: moment().subtract(1, 'quarter').startOf('quarter'),
            endDate: moment().subtract(1, 'quarter').endOf('quarter'),
        }),
    },
    {
        labelKey: 'Last Half Year',
        getRange: () => ({
            startDate: moment().subtract(2, 'quarters').startOf('quarter'),
            endDate: moment().subtract(1, 'quarter').endOf('quarter'),
        }),
    },
    {
        labelKey: 'Last Year',
        getRange: () => ({
            startDate: moment().subtract(1, 'year').startOf('year'),
            endDate: moment().subtract(1, 'year').endOf('year'),
        }),
    },
];
